/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import { HiCheck, HiX } from "react-icons/hi";
import PropTypes from "prop-types";
import { PDP_LABELS } from "@/components/detailsComponent/helper";
import Loader from "@/components/loader";
import MissingImage from "/public/image-missing.png";

import {
  DEFAULT_IMAGE_LINK,
  staticLabelsPLP,
  getColorSwatchesPlpModal,
  imageURLWithPresetConfigQuickView,
} from "@/components/ProductListing/helper";
import Image from "next/legacy/image";
import { getRequiredPrice, getRequiredSpecification } from "@/utils/helper";
import { NumericFormat } from "react-number-format";
import { useRouter } from "next/router";
import { UseLocalStorage } from "../CustomHooks/LocalStorage";

export default function PLPModal({
  handleModalClose,
  modalItem,
  locale,
  skuId,
  addToCompare,
  removeFromCompare,
  displayQuickViewMasterPLP = true,
  plpCompareData = {},
}) {
  const {
    description = "",
    productCollectionsName = "",
    masterCustomerFacingSKU = "",
    productSalePrice = 0,
    productImagesUrlSS = [],
    productImagesLabelWithUrlSS = [],
    sku = "",
    colors = [],
    productVariantImages = [],

    originalData: {
      SKUColorSwatchFilename_ss: colorFinishCodeArray = [],
      SKUColorFinishName_ss: colorFinishNameArray = [],
      productName_s: productNames = "",
      RegionBrandName_ss: regionBrandName = [],
      "Color.GST.Details_ss": colorGSTDetails = [],
    } = {},
  } = modalItem;

  const swatchColors = getColorSwatchesPlpModal(colors);

  const compareProducts = UseLocalStorage("compareProducts");
  const isProductCompared = compareProducts?.some(
    item =>
      item?.compareMappedValues?.skuId ===
      plpCompareData?.compareMappedValues?.skuId
  );

  const color = getRequiredSpecification(colors, sku, 2, 0);
  const swatchFileName = getRequiredSpecification(colors, sku, 2, 1);
  const [modalValues] = useState({});
  const router = useRouter();
  const [skuNumber, setSkuNumber] = useState(sku);
  const [price, setPrice] = useState(productSalePrice);
  const [loader, setLoader] = useState(false);
  const [discontinuedBanner, setDiscontinuedBanner] = useState(false);
  const [selectedColorName, setSelectedColorName] = useState(color);
  const [swatchName, setSelectedSwatch] = useState(swatchFileName);

  const initialImageResource = getRequiredSpecification(
    productVariantImages,
    skuNumber,
    0,
    5
  );

  const [selectedImageResource, setSelectedImageResource] =
    useState(initialImageResource);
  // Color tiles are clickable
  const setColorImageFeature = (e, swatchName = "") => {
    e.preventDefault();
    const selectedColorName = getRequiredSpecification(
      colors,
      swatchName,
      1,
      0
    );
    setSelectedColorName(selectedColorName);
    setSelectedSwatch(swatchName);
    const selectedSku = getRequiredSpecification(colors, swatchName, 1, 2);
    setSkuNumber(selectedSku);
    const imageResource = getRequiredSpecification(
      productVariantImages,
      selectedSku,
      0,
      5
    );
    setSelectedImageResource(imageResource);
    const finalPrice = getRequiredPrice(colorGSTDetails, selectedSku, 0, 2);
    setPrice(finalPrice);
  };

  const handleCompareComponent = () => {
    if (isProductCompared) {
      if (removeFromCompare) removeFromCompare();
    } else {
      if (addToCompare) addToCompare();
    }
  };

  const productImagePath =
    imageURLWithPresetConfigQuickView(
      selectedImageResource?.split("/")?.slice(-1)?.[0]
    ) || MissingImage;

  return (
    <div
      className="relative z-200 max-[1024px]:hidden"
      aria-labelledby={modalItem.ProductBrandName}
      aria-modal="true"
      onClick={handleModalClose}
    >
      <div className="fixed inset-0 bg-[#2b2e38e6] [backface-visibility:hidden] bg-opacity-80 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <div className="relative transform overflow-hidden bg-white text-left shadow-xl transition-all max-w-screen-lg mx-auto">
            {loader && <Loader loading={loader} />}
            {discontinuedBanner && (
              <div className="flex h-[30px] items-center justify-center py-5 bg-[#FF0000] drop-shadow-lg text-[#fff] font-semibold">
                {PDP_LABELS[locale].discontinued}
              </div>
            )}
            <div
              className="flex sm:flex-row flex-col"
              onClick={e => e.stopPropagation()}
            >
              <a
                className="flex cursor-pointer"
                href={`/product-details/${modalItem.slug || modalItem?.originalData?.slug_s}?sku=${modalItem.sku || modalItem?.originalData?.sku_s}`}
              >
                <img
                  src={productImagePath}
                  alt={selectedImageResource}
                  className="sm:h-[415px] sm:w-[560px] h-[240px] w-full"
                  onError={e =>
                    (e.target.src = selectedImageResource || DEFAULT_IMAGE_LINK)
                  }
                />
              </a>
              <div className="flex flex-col md:w-[400px] w-full lg:pl-[45px] lg:pl-[15px] p-[5%]">
                <div
                  className="cursor-pointer text-[18px] font-['helveticaBold',_Helvetica,_sans-serif] font-semibold mb-[20px] leading-[18px]"
                  onClick={() =>
                    router.push(
                      `/product-details/${modalItem.slug || modalItem?.originalData?.slug_s}?sku=${modalItem.sku || modalItem?.originalData?.sku_s}`
                    )
                  }
                >
                  {regionBrandName?.[0] || ""}
                  {productNames && (
                    <span className="text-[18px] font-['Helvetica-Light',_Helvetica,_sans-serif] font-light">
                      {" "}
                      {productNames}
                    </span>
                  )}
                </div>

                {skuNumber && (
                  <div className="font-['HelveticaRoman',_Helvetica,_sans-serif] text-[16px] leading-tight font-normal text-[#666]">
                    K-{skuNumber}
                  </div>
                )}
                {price && Number(price) !== 0 && (
                  <div className="font-['Helvetica-Light',_Helvetica,_sans-serif] text-[18px] leading-tight font-bold text-[#232323] mt-[16px]">
                    <NumericFormat
                      aria-description={"price"}
                      value={price}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"IDR "}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </div>
                )}
                <div className="mt-[20px] mb-[10px]">
                  <span className="font-['helveticaBold',_Helvetica,_sans-serif] text-[17px] leading-tight text-[#000]">
                    {staticLabelsPLP[locale].colorLabel}:
                  </span>
                  {selectedColorName && (
                    <span className="ml-[10px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[16px] leading-tight font-light">
                      {selectedColorName}
                    </span>
                  )}
                </div>
                <div className="flex flex-wrap">
                  {swatchColors?.map((el, index) => (
                    <div
                      key={index}
                      title={el.styleName}
                      className="mx-1 relative inline-block pb-2 cursor-pointer"
                      onClick={e => setColorImageFeature(e, el.swatchName)}
                    >
                      <Image
                        src={el.src}
                        alt={el.styleName}
                        onError={e => (e.target.src = DEFAULT_IMAGE_LINK)}
                        height={30}
                        width={30}
                      />
                      {swatchName === el.swatchName && (
                        <div className="absolute top-0 right-0 h-[30px] w-[30px] bg-cover border-2 border-neutral-500">
                          <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-[#fff]">
                            <HiCheck size={30} />
                          </div>
                        </div>
                      )}
                      {/* {selectedColorName && (
                        <span className="absolute top-full p-[10px] bg-[#f9f9f9] border-1 border-neutral-500 rounded-md shadow font-helvetica leading-tight text-[13px] w-max z-10 hidden sm:block">
                          {selectedColorName}
                        </span>
                      )} */}
                    </div>
                  ))}
                </div>
                {displayQuickViewMasterPLP && (
                  <button
                    className="flex uppercase justify-center items-center mr-3 h-[40px] bg-[#e5e5e5] text-[#232323] rounded hover:bg-[#bebebe] hover:text-[#232323] py-[13px] px-[20px] text-[13px] font-[HelveticaBold, Helvetica, sans-serif] font-[800] w-fit"
                    onClick={handleCompareComponent}
                  >
                    {isProductCompared ? "-" : "+"}{" "}
                    {PDP_LABELS[locale]?.compareLabel || "Compare"}
                  </button>
                )}
              </div>

              <button
                className="absolute top-0 right-0 p-3 opacity-50 hover:opacity-95 cursor-pointer"
                onClick={() => handleModalClose()}
              >
                <HiX size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
PLPModal.propTypes = {
  modalItem: PropTypes.shape({
    ProductBrandName: PropTypes.string,
    productCollectionsName: PropTypes.string,
    masterCustomerFacingSKU: PropTypes.string,
    originalData: PropTypes.object,
  }),
  handleModalClose: PropTypes.func,
  ProductProductNo: PropTypes.string,
  locale: PropTypes.string,
  skuId: PropTypes.string,
};
